import store from '../../config/configureStore';
import { errorTree, getActiveErrors } from 'simpl-schema-validation/helpers/errorTree';

export const countOffenseErrors = (ptsOffenseId) => {
  let currentIncidentId = store.store.getState().incident.ptsIncidentId;
  let validationErrors = store.store.getState().incident.validationErrors;

  const errorObj = validationErrors.find((error) => error.ptsIncidentId == currentIncidentId);

  if (!errorObj) {
    return 0;
  }
  let errorCount = 0;

  for (let subStepperError of errorTree['offensesErrors']) {
    const activeErrors = getActiveErrors(errorObj.errors?.[subStepperError]);
    if (activeErrors?.length) {
      activeErrors.forEach((error) => {
        if (error.ptsOffenseId === ptsOffenseId) {
          errorCount++;
        }
      });
    }
  }

  return errorCount;
};
